<router-outlet></router-outlet>

<footer class="tw-text-center tw-my-12">
  <environment-selector></environment-selector>

  <div bitTypography="body2">Vaultwarden Web (Powered by DigitalAdrenaline)</div>
  <div bitTypography="body2">{{ version }}</div>
</footer>
